module.exports = __webpack_public_path__ + "3be5c5e46905c9dce686a5fa07a6bf96.svg";